import React from "react";
import CrossDetail from "../../../widgets/supervisor/cross-detail/CrossDetail";
import Layout from "../Layout";

function CrossDetailsPage(props) {
  return (
    <Layout>
      <CrossDetail />
    </Layout>
  );
}

export default CrossDetailsPage;
